import { LocalStorageController } from '../../../util/local-storage-controller';

const TRANSLATION_LANGUAGE_SELECTION_KEY = 'TeamEngine.TranslationLanguageSelection';

export const getCachedSelectedTranslationLanguage = () =>
  LocalStorageController.getItem(TRANSLATION_LANGUAGE_SELECTION_KEY);

export const setCachedSelectedTranslationLanguage = (value: string) => {
  LocalStorageController.setItem(TRANSLATION_LANGUAGE_SELECTION_KEY, value);
};
